import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AbstractCrudService } from '../../service/abstract.crud.service';

@Injectable({
  providedIn: 'root'
})
export class ProcedimentoConsultaService extends AbstractCrudService {

  protected getBaseUrlPublic(): string {
    return super.getBaseUrlPublic() + 'procedimentoConsulta';
  }

  protected getBaseUrlPrivate(): string {
    return super.getBaseUrlPrivate() + 'procedimentoConsulta';
  }

  listarConsultasDisponiveisDTO(): Observable<any> {
    return this.http.get(`${this.getBaseUrlPublic()}/consultasDisponiveisDTO`);
  }

  listarComProjecao(): Observable<any> {
    return this.http.get(`${this.getBaseUrlPrivate()}/comProjecao`);
  }

  listarConsultasPorEspecialidadeComProjecao(idEspecialidade: number): Observable<any> {
    return this.http.get(`${this.getBaseUrlPrivate()}/comProjecao/especialidade/${idEspecialidade}`);
  }
}
